export const levelPalettes = [
  { name: 'Carmesí', surface: '#9d0306', rim: '#edbd60', light: '#ffbd54', text: '#fff5af', metalFilter: 'none' },
  { name: 'Jade', surface: '#026b15', rim: '#d7e2dc', light: '#54ff9c', text: '#fff5af', metalFilter: 'grayscale(1) brightness(1.15)' },
  { name: 'Zafiro', surface: '#17347d', rim: '#cfdeed', light: '#3fb8ff', text: '#fff5af', metalFilter: 'grayscale(1) brightness(1.12) sepia(.15) hue-rotate(155deg)' },
  { name: 'Ciruela', surface: '#350c36', rim: '#eac8b1', light: '#e79bff', text: '#fff5af', metalFilter: 'grayscale(.85) sepia(.35) hue-rotate(310deg)' },
];

export function rangeProgress(level) {
  const amount = Number.parseFloat(level.winAmount) || 0;
  const min = Number(level.minAmount) || 0;
  const max = Number(level.maxAmount) || 0;
  if (max <= min) return amount >= max ? 100 : 0;
  return Math.max(0, Math.min(100, (amount - min) / (max - min) * 100));
}

export function progressColor(value) {
  const stops = [[0, [111, 219, 172]], [40, [242, 210, 91]], [70, [255, 150, 53]], [100, [255, 65, 68]]];
  const safe = Math.max(0, Math.min(100, Number(value) || 0));
  const end = stops.findIndex(([at]) => at >= safe);
  if (end <= 0) return 'rgb(111, 219, 172)';
  const [a, start] = stops[end - 1];
  const [b, finish] = stops[end];
  const ratio = (safe - a) / (b - a);
  return `rgb(${start.map((channel, i) => Math.round(channel + (finish[i] - channel) * ratio)).join(', ')})`;
}

// Reducción de ancho entre un nivel y el siguiente (fracción del ancho del primero).
export const WIDTH_STEP = .08;

export function getPreviewLayout(width, height, count) {
  const n = Math.max(1, Math.min(6, count));
  const narrow = width < 760;
  const w = width * (narrow ? .94 : .57);
  const weights = [1, .93, .88, .84, .8, .76].slice(0, n);
  const gap = height * .008;
  const baseHeight = Math.min((height * .82 - gap * (n - 1)) / weights.reduce((sum, weight) => sum + weight, 0), w / 3.15);
  const totalHeight = baseHeight * weights.reduce((sum, weight) => sum + weight, 0) + gap * (n - 1);
  let top = height * .54 - totalHeight / 2;
  return weights.map((weight, i) => {
    const h = baseHeight * weight;
    const position = { width: w * (1 - i * WIDTH_STEP), height: h, x: 0, y: height / 2 - top - h / 2 };
    top += h + gap;
    return position;
  });
}
